import { ReactNode } from "react";
// @mui
import { Box, Link, Typography, useTheme } from "@mui/material";
//
import Breadcrumbs, { Props as BreadcrumbsProps } from "./Breadcrumbs";

// ----------------------------------------------------------------------

interface Props extends BreadcrumbsProps {
  action?: ReactNode;
  heading: string | ReactNode;
  subtitle?: string;
  moreLink?: string | string[];
  homeIcon: string;
}

export default function HeaderBreadcrumbs({
  links,
  action,
  heading,
  subtitle,
  homeIcon,
  moreLink = [],
  sx,
  ...other
}: Props) {
  const theme = useTheme();
  return (
    <Box sx={{ mb: 5, mt: 5, ...sx }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ flexGrow: 1 }} data-testid="trending-brands-header">
          <Breadcrumbs homeIcon={homeIcon} links={links} {...other} />
          {typeof heading === "string" ? (
            <Typography variant="h3" gutterBottom sx={{ mt: theme.spacing(3) }}>
              {heading}
            </Typography>
          ) : (
            <Box sx={{ flexShrink: 0 }}>{heading}</Box>
          )}
          {subtitle && typeof subtitle === "string" && (
            <Typography variant="subtitle1" gutterBottom>
              {subtitle}
            </Typography>
          )}
          {subtitle && typeof subtitle !== "string" && (
            <Typography variant="subtitle1" gutterBottom>
              {subtitle}
            </Typography>
          )}
        </Box>

        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>

      <Box sx={{ mt: 2 }}>
        {typeof moreLink === "string" ? (
          <Link href={moreLink} target="_blank" rel="noopener" variant="body2">
            {moreLink}
          </Link>
        ) : (
          moreLink.map((href) => (
            <Link
              noWrap
              key={href}
              href={href}
              variant="body2"
              target="_blank"
              rel="noopener"
              sx={{ display: "table" }}
            >
              {href}
            </Link>
          ))
        )}
      </Box>
    </Box>
  );
}
